$(document).ready(function(){
	if($('.category-slider').length) {
		$('.category-slider').slick({
			centerMode:true,
			centerPadding:'104px',
			slidesToShow:3,
			arrows:false,
			dots:false,
			responsive: [
				{
					breakpoint: 1025,
					settings: {
						slidesToShow: 1
					}
				},
				{
					breakpoint: 769,
					settings: {
						centerPadding:'60px',
						slidesToShow: 1
					}
				}
			]
		});
	}
});

$(document).on('click', '.faq-item > a', function(){
	$(this).closest('.faq-item').toggleClass('active');
	$(this).closest('.faq-item').find('.rte').slideToggle();
});

$(document).on('click', '.atc-option-name', function(){
	$(this).toggleClass('atc-options-open');
	$(this).closest('.atc-variants-container').find('.atc-option-values').slideToggle();
});

$(document).on('click', '.atc-option-values a', function(){
	var $this = $(this),
	$available = $this.data('available'),
	$id = $this.data('value'),
	$label = $this.find('.atc-option').text(),
	$price = $this.data('price'),
	$inventory = $this.data('quantity');
	$this.closest('.custom-product-card').find('.product-meta p').html($price);
	$this.closest('.atc-variants-container').find('.atc-label').html($label);
	$this.closest('.custom-product-card').find('.inventory-count span').html($inventory);
	if($available) {
		$this.closest('.custom-product-card').find('.atc-buy-now .atc-btn-text').text('Buy Now');
	} else {
		$this.closest('.custom-product-card').find('.atc-buy-now .atc-btn-text').text('Sold Out');
	}
	$this.closest('.custom-product-card').find('.atc-buy-now').data('variant-id', $id);
	$this.closest('.atc-options-open').removeClass('.atc-options-open');
	$this.closest('.atc-option-values').slideUp();
});

$(document).on('click', 'a.atc-buy-now:not(.disabled)', function(){
	var $this = $(this),
	$id = $this.data('variant-id');
	$this.addClass('disabled').find('.atc-btn-text').text('Adding...');
	var $data = [];
	$data.push({
		'quantity': 1,
		'id': $id,
	});
	$.ajax({
		type: 'POST',
		url: '/cart/add.js',
		dataType: 'json',
		data: {
			items: $data
		},
		success: function (response) {
			window.location.href = '/checkout';
		},
		error: function (response, a, b) {
			if (response) {
				alert(response?.responseJSON?.description || 'An error has occurred.')
				return;
			}
		}
	});
});

$(document).ready(function(){
	$('.block__tab-card-grid-link').on('click', function(e){
		var $this = $(this);
		$target = $this.parents('.block__tab-card-grid-item').find('.block_tab_popup_wrapper');
		$this.addClass('active');
		$target.addClass('active');
		var $activeSlider = $('.block_tab_popup_wrapper.active .block_tab_popup_inner');
		if ($activeSlider.find('.block__tab-card-grid-image').length > 1) {
			cardGridImage();
		}
		$('body').addClass('popup_open');

	});

	$('.block__card-grid-tab-close').on('click', function(e){
		var $this = $(this);
		$target = $this.parents('.block_tab_popup_wrapper');
		$this.closest('.block__tab-card-grid-link').removeClass('active');
		$target.removeClass('active');
		$('body').removeClass('popup_open');

	});


	

});

function cardGridImage(){
		$('.block_tab_popup_wrapper.active .block_tab_popup_inner').slick({
			slidesToShow:1,
			arrows:true,
			dots:false,
			adaptiveHeight: true,
			infinite: false,
		});
}